import { Mtds } from 'prove-common'
import { type FileError } from 'react-dropzone'
import { ReactNode } from 'react'

type FileItemProps = {
  fileName: string
  errors?: readonly FileError[]
  rightElement?: ReactNode
}

const DROPZONE_MESSAGES: Record<string, string> = {
  'file-too-large':
    'The file is too large. Reduce the file size and try again.',
  'file-too-small': 'The file is too small.',
  'file-invalid-type': 'Only PDF files are allowed.',
  'too-many-files': 'Too many files. Upload one file at a time.'
}

const visibleMessage = (error: FileError): string =>
  DROPZONE_MESSAGES[error.code] ?? error.message

const FileItem = ({ fileName, errors, rightElement }: FileItemProps) => {
  const hasErrors = errors != null && errors.length > 0
  return (
    <li>
      <Mtds.Card
        as={Mtds.Flex}
        data-justify='space-between'
        data-align='center'
      >
        {fileName}
        {rightElement}
        {hasErrors && (
          <Mtds.Grid data-color={'danger'}>
            {errors.map((e) => (
              <Mtds.Validation key={e.code} data-color={'warning'}>
                {visibleMessage(e)}
              </Mtds.Validation>
            ))}
          </Mtds.Grid>
        )}
      </Mtds.Card>
    </li>
  )
}

export default FileItem
